import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  TextField,
  Button,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import useStore from 'src/store/cns';
import { setApprovalForAll } from 'src/utils/contracts/registry';
import { handleError } from 'src/utils/errors/common';
import { isValidAddress } from 'src/utils/common';
import { Chain } from 'src/types/enums';

const Operator = () => {
  const [operator, setOperator] = useState<string>('');
  const operators = useStore(state => state.operators);
  const setOperators = useStore(state => state.setOperators);

  const handleUpdate = async (operator: string, isApproved: boolean) => {
    try {
      await setApprovalForAll(operator, isApproved);
      if (isApproved) {
        setOperators(operators.concat(operator));
      } else {
        const newArray = [...operators];
        const index = newArray.indexOf(operator);
        newArray.splice(index, 1);
        setOperators(newArray);
      }
      setOperator('');
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Operators
        </Typography>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="operators table">
            <TableBody>
              {operators.map((operator, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {operator.slice(0, 6)} ... {operator.slice(-4)}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      aria-label="delete"
                      onClick={() => handleUpdate(operator, false)}
                    >
                      <Delete sx={{ color: 'red' }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={8}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Enter operator address"
          value={operator}
          onChange={e => setOperator(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: '46px',
              '&:hover fieldset': {
                borderColor: 'grey.600',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'grey.600',
              },
            },
          }}
          title={
            !isValidAddress(operator, Chain.C)
              ? 'Must be a valid C-Chain address'
              : ''
          }
        />
      </Grid>
      <Grid item xs={4}>
        <Button
          variant="contained"
          fullWidth
          sx={{
            color: 'text.primary',
            backgroundColor: 'primary.main',
            padding: '10px 16px',
          }}
          onClick={() => handleUpdate(operator, true)}
          disabled={!isValidAddress(operator, Chain.C)}
        >
          Add
        </Button>
      </Grid>
    </Grid>
  );
};

export default React.memo(Operator);
